<template>
    <div class="h-full">
        <iframe src="/usermanual.pdf" width="100%" height="100%" frameborder="0"></iframe>
    </div>
</template>

<script>
export default {
    name: 'UserManual',
}
</script>

<style scoped>

</style>